import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { legacyGinActionRoute } from '@jira/router-routes__legacy-gin-action-routes/src/legacyGinActionRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyGinActionRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyGinActionRoute,
	() => ({
		layout: globalLayout,

		navigation: {
			menuId: MenuIdFilters,
		},

		resources: [navigationSidebarGlobalResource],
		entryPoint: () => pageEntryPoint,
	}),
);
